import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { DashCodeHelper } from '@app/_shared/_helpers/dashcode.helper';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';
declare var smartsupp: any;

@Component({
  selector: 'dashlayout',
  templateUrl: './dashlayout.component.html',
  styleUrls: ['./dashlayout.component.scss']
})
export class DashlayoutComponent implements OnInit {

  constructor(public dashcodeHelper: DashCodeHelper,private globalHelper:GlobalHelper, private el:ElementRef) { }



  ngAfterViewInit(): void {
    this.globalHelper.loadExternalStyles(this.el,'theme/DASHCODE/css/sidebar-menu.css','DASHCODE');
    this.globalHelper.loadExternalStyles(this.el,'theme/DASHCODE/css/app.css','DASHCODE');
  }
  ngOnInit(): void {
    this.dashcodeHelper.documentReadyFunctions();

    // Vérifier que smartsupp est chargé avant de l'appeler
    if (typeof smartsupp !== 'undefined') {
      smartsupp('chat:hide');
    }
  }


}
